import { useCallback, useContext, useEffect, useState } from "react";
import { TeamContext } from "../context";
import { IPlayer } from "../interfaces";

const useBoardDisplayView = (): [boolean, IPlayer[]] => {
    const { game } = useContext(TeamContext);

    const [isAnyUserCurrentlyLoggedOut, setIsAnyUserCurrentlyLoggedOut] = useState<boolean>(false);
    const [listOfTheUsersWhoLoggedout, setListOfTheUsersWhoLoggedout] = useState<IPlayer[]>([]);

    const checkIfAnyOfTheUsersLoggedOutDuringTheGame = useCallback(() => {
        let listOfThePlayers = game?.gameInfo?.players;
        let isAnyUserOut = false;
        let helperArray = [];

        setListOfTheUsersWhoLoggedout([]);

        for (const playerEmail in listOfThePlayers) {
            if (listOfThePlayers[playerEmail].status === 3) {

                let expectedPlayer = game?.players.find((player: IPlayer) => { return player.email === playerEmail });
                isAnyUserOut = true;

                if (expectedPlayer) {
                    helperArray.push(expectedPlayer);
                }
            }
        }

        setListOfTheUsersWhoLoggedout(helperArray);

        if (isAnyUserOut)
            setIsAnyUserCurrentlyLoggedOut(true);
       
        if (!isAnyUserOut)
            setIsAnyUserCurrentlyLoggedOut(false);
        
    }, [game?.gameInfo?.players, game?.players]);

    useEffect(() => {
        checkIfAnyOfTheUsersLoggedOutDuringTheGame();
    }, [game?.gameInfo?.players, checkIfAnyOfTheUsersLoggedOutDuringTheGame]);


    return [isAnyUserCurrentlyLoggedOut, listOfTheUsersWhoLoggedout];
}

export default useBoardDisplayView;